/* eslint-disable no-case-declarations */
import { actionCreator } from 'utils';
import * as ProductGroupTypes from '../types/productGroupTypes';

const listingPackages = {
    loading: false,
    error: false,
    listing: [],
    offset: 0,
    limit: 10,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        name: '',
        created_by: [],
    },
    users: {
        loading: false,
        data: [],
    },
    displayUsers: [],
};

const initState = {
    loading: false,
    error: false,
    success: false,
    offset: 0,
    limit: 10,
    listing: {},
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    filters: {
        name: '',
    },
    checked: {
        loading: false,
        ids: [],
    },
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        newPackages: [],
        deletePackages: [],
        error: false,
        success: false,
    },
    sellPrice: {
        loading: false,
        error: false,
        listing: null,
        productGroup: {
            loading: false,
            error: false,
            data: null,
        },
        filters: {
            'configuration_property.carrier_id': [],
            'configuration_property.property_value_id': [],
            configuration_type: [],
            'name.translate': '',
            'cost_durations.partner_id': [],
        },
        offset: 0,
        limit: 10,
        sort: {
            key: 'created_at',
            type: 'desc',
        },
        resellers: {
            selected: null,
        },
        partners: {
            loading: false,
            error: false,
            listing: null,
        },
        update: {
            loading: [],
            error: false,
            success: [],
        },
        checked: [],
        statusLoading: [],
    },
    chosen_packages: {
        loading: false,
        data: null,
        offset: 0,
        limit: 10,
        error: false,
        success: false,
        sort: {
            key: 'created_at',
            type: 'desc',
        },
        filters: {
            name: '',
            created_by: [],
        },
        users: {
            loading: false,
            data: [],
        },
        displayUsers: [],
    },
    bulk: {
        packages: [],
        loading: false,
        error: false,
    },
    bulkDelete: {
        packages: [],
        loading: false,
        error: false,
    },
    packages: { ...listingPackages, limit: 10 },
};

export default function (state = initState, action) {
    switch (action.type) {
    case ProductGroupTypes.LOAD_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(ProductGroupTypes.LOAD_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(ProductGroupTypes.LOAD_PRODUCT_GROUPS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case ProductGroupTypes.SET_PRODUCT_GROUPS_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(ProductGroupTypes.SET_PRODUCT_GROUPS_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case ProductGroupTypes.SET_PRODUCT_GROUPS_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case ProductGroupTypes.SET_PRODUCT_GROUPS_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case ProductGroupTypes.RESET_PRODUCTS_GROUPS_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    case ProductGroupTypes.TOGGLE_PRODUCT_GROUPS_STATUS:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: action.id,
            },
        });

    case actionCreator(ProductGroupTypes.TOGGLE_PRODUCT_GROUPS_STATUS, 'res') || actionCreator(ProductGroupTypes.TOGGLE_PRODUCT_GROUPS_STATUS, 'err'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case ProductGroupTypes.SET_CHECKED_GROUPS_STATUS:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                ids: action.ids,
            },
        });

    case ProductGroupTypes.BULK_CHECKED_GROUPS_STATUS:
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: action.ids,
            },
        });

    case actionCreator(ProductGroupTypes.BULK_CHECKED_GROUPS_STATUS, 'res'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
                ids: action.ids,
            },
        });

    case actionCreator(ProductGroupTypes.BULK_CHECKED_GROUPS_STATUS, 'err'):
        return Object.assign({}, state, {
            checked: {
                ...state.checked,
                loading: false,
            },
        });

    case ProductGroupTypes.ADD_NEW_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.ADD_NEW_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: action.loading,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.ADD_NEW_PRODUCT_GROUPS, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case ProductGroupTypes.UPDATE_TRANSLATE_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.UPDATE_TRANSLATE_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            [action.key]: Object.assign({}, state[action.key], {
                loading: action.loading,
                success: action.success,
            }),
        });

    case ProductGroupTypes.GO_TO_STEP_OF_PRODUCT_GROUPS_FORM:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                current: action.step,
            }),
        });

    case ProductGroupTypes.LOAD_EDITABLE_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_EDITABLE_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_EDITABLE_PRODUCT_GROUPS, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case ProductGroupTypes.EDIT_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.EDIT_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(ProductGroupTypes.EDIT_PRODUCT_GROUPS, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case ProductGroupTypes.SET_EMPTY_EDITABLE_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    case ProductGroupTypes.LOAD_SELL_PRICE:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_SELL_PRICE, 'res'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_SELL_PRICE, 'err'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                loading: false,
                error: true,
            }),
        });

    case ProductGroupTypes.LOAD_PRODUCT_GROUP_FOR_SELL_PRICE:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                productGroup: Object.assign({}, state.sellPrice.productGroup, {
                    loading: true,
                    error: false,
                }),
            }),
        });


    case actionCreator(ProductGroupTypes.LOAD_PRODUCT_GROUP_FOR_SELL_PRICE, 'res'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                productGroup: Object.assign({}, state.sellPrice.productGroup, {
                    loading: false,
                    data: action.data,
                }),
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_PRODUCT_GROUP_FOR_SELL_PRICE, 'err'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                productGroup: Object.assign({}, state.sellPrice.productGroup, {
                    error: true,
                    loading: false,
                }),
            }),
        });

    case ProductGroupTypes.SET_EMPTY_PRODUCT_GROUP_FROM_SELL_PRICE:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                productGroup: Object.assign({}, state.sellPrice.productGroup, initState.sellPrice.productGroup),
            }),
        });


    case ProductGroupTypes.SET_RESELLER_FOR_SELL_PRICE:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                resellers: Object.assign({}, state.sellPrice.resellers, {
                    selected: action.id,
                }),
            }),
        });

    case ProductGroupTypes.UPDATE_SELL_PRICE:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                update: Object.assign({}, state.sellPrice.update, {
                    loading: [
                        ...state.sellPrice.update.loading,
                        ...action.data.map(s => s.cost_and_duration_id),
                    ],
                    error: false,
                }),
            }),
        });

    case actionCreator(ProductGroupTypes.UPDATE_SELL_PRICE, 'res'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                update: {
                    ...state.sellPrice.update,
                    loading: state.sellPrice.update.loading.filter(c => !action.payload.includes(c)),
                    success: [...state.sellPrice.update.success, ...action.payload],
                },
            }),
        });

    case actionCreator(ProductGroupTypes.UPDATE_SELL_PRICE, 'req'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                update: {
                    ...state.sellPrice.update,
                    success: state.sellPrice.update.success.filter(c => !action.payload.includes(c)),
                },
            }),
        });

    case actionCreator(ProductGroupTypes.UPDATE_SELL_PRICE, 'err'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                update: Object.assign({}, state.sellPrice.update, {
                    error: true,
                    loading: [],
                }),
            }),
        });

    case ProductGroupTypes.SET_CHECKED_SELL_PRICE:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                checked: action.ids,
            }),
        });

    case ProductGroupTypes.TOGGLE_COST_STATUS_BY_SELL_PRICE:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                statusLoading: action.ids,
            }),
        });

    case actionCreator(ProductGroupTypes.TOGGLE_COST_STATUS_BY_SELL_PRICE, 'res'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                statusLoading: [],
                checked: [],
            }),
        });

    case actionCreator(ProductGroupTypes.TOGGLE_COST_STATUS_BY_SELL_PRICE, 'err'):
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                statusLoading: [],
            }),
        });

    case ProductGroupTypes.SET_SELL_PRICE_PAGINATION:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                [action.key]: action.value,
            }),
        });

    case ProductGroupTypes.SET_SELL_PRICE_FILTERS:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                loading: true,
                filters: {
                    ...state.sellPrice.filters,
                    [action.key]: action.value,
                },
            }),
        });

    case ProductGroupTypes.SET_SELL_PRICE_SORT:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                sort: action.sort,
            }),
        });

    case ProductGroupTypes.RESET_SELL_PRICE_FILTERS:
        return Object.assign({}, state, {
            sellPrice: Object.assign({}, state.sellPrice, {
                filters: initState.sellPrice.filters,
            }),
        });

    case ProductGroupTypes.ADD_BULK_PACKAGES_FOR_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.ADD_BULK_PACKAGES_FOR_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: false,
            }),
        });

    case actionCreator(ProductGroupTypes.ADD_BULK_PACKAGES_FOR_PRODUCT_GROUPS, 'err'):
        return Object.assign({}, state, {
            bulk: Object.assign({}, state.bulk, {
                loading: false,
                error: action.error,
            }),
        });

    case ProductGroupTypes.DELETE_BULK_PACKAGES_FOR_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            bulkDelete: Object.assign({}, state.bulkDelete, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.DELETE_BULK_PACKAGES_FOR_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            bulkDelete: Object.assign({}, state.bulkDelete, {
                loading: false,
            }),
        });

    case actionCreator(ProductGroupTypes.DELETE_BULK_PACKAGES_FOR_PRODUCT_GROUPS, 'err'):
        return Object.assign({}, state, {
            bulkDelete: Object.assign({}, state.bulkDelete, {
                loading: false,
                error: action.error,
            }),
        });

    case ProductGroupTypes.LOAD_PACKAGES_FOR_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                loading: true,
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_PACKAGES_FOR_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                loading: false,
                listing: action.data,
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_PACKAGES_FOR_PRODUCT_GROUPS, 'err'):
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                loading: false,
                error: true,
            }),
        });

    case ProductGroupTypes.LOAD_EDITTABLE_PACKAGES_FROM_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            chosen_packages: Object.assign({}, state.chosen_packages, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_EDITTABLE_PACKAGES_FROM_PRODUCT_GROUPS, 'res'):
        return Object.assign({}, state, {
            chosen_packages: Object.assign({}, state.chosen_packages, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_EDITTABLE_PACKAGES_FROM_PRODUCT_GROUPS, 'err'):
        return Object.assign({}, state, {
            chosen_packages: Object.assign({}, state.chosen_packages, {
                loading: false,
                error: true,
            }),
        });

    case ProductGroupTypes.LOAD_DISPLAY_USERS_FOR_ATTACHED_PACKAGES:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                displayUsers: action.data,
            }),
        });

    case ProductGroupTypes.UPDATE_PACKAGES_TO_LIST_PRODUCT_GROUPS:
        const { payload, id, data } = action;
        const setReturn = {};

        if (payload === 'new' && 'packages' in state.edit.data) {
            if (state.edit.data.packages.includes(id)) {
                setReturn.deletePackages = state.edit.deletePackages.filter(p => p !== id);
            } else if (!state.edit.newPackages.map(p => p.id).includes(id)) {
                setReturn.newPackages = state.edit.newPackages.concat(data);
            }
        }

        if (payload === 'delete' && 'packages' in state.edit.data) {
            if (state.edit.data.packages.includes(id)) {
                setReturn.deletePackages = state.edit.deletePackages.concat(id);
            } else if (state.edit.newPackages.map(p => p.id).includes(id)) {
                setReturn.newPackages = state.edit.newPackages.filter(p => p.id !== id);
            }
        }

        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, setReturn),
        });

    case ProductGroupTypes.RESET_PACKAGE_FROM_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                deletePackages: [],
                newPackages: [],
            }),
        });

    case ProductGroupTypes.RESET_CHOSEN_PACKAGES_PAGINATION_FROM_PRODUCT_GROUP:
        return Object.assign({}, state, {
            chosen_packages: Object.assign({}, state.chosen_packages, {
                offset: 0,
            }),
        });

    case ProductGroupTypes.SET_CHECKED_PACKAGES_FOR_PRODUCT_GROUPS:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                checked: action.ids,
            }),
        });

    case ProductGroupTypes.SET_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                [action.key]: action.pagination,
            }),
        });

    case ProductGroupTypes.SET_PACKAGES_SORT_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                sort: action.sort,
            }),
        });

    case ProductGroupTypes.SET_PACKAGES_FILTERS_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                loading: true,
                filters: {
                    ...state.packages.filters,
                    [action.key]: action.value,
                },
            }),
        });

    case ProductGroupTypes.SET_CHOSEN_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            chosen_packages: Object.assign({}, state.chosen_packages, {
                [action.key]: action.pagination,
            }),
        });

    case ProductGroupTypes.SET_CHOSEN_PACKAGES_SORT_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            chosen_packages: Object.assign({}, state.chosen_packages, {
                sort: action.sort,
            }),
        });

    case ProductGroupTypes.SET_CHOSEN_PACKAGES_FILTERS_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            chosen_packages: Object.assign({}, state.chosen_packages, {
                loading: true,
                filters: {
                    ...state.chosen_packages.filters,
                    [action.key]: action.value,
                },
            }),
        });

    case ProductGroupTypes.LOAD_USERS_FOR_PACKAGE:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                users: {
                    ...state.packages.users,
                    loading: true,
                },
            }),
        });

    case actionCreator(ProductGroupTypes.LOAD_USERS_FOR_PACKAGE, 'res'):
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                users: {
                    ...state.packages.users,
                    loading: false,
                    data: action.data,
                },
            }),
        });

    case ProductGroupTypes.RESET_PACKAGES_FILTERS_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                filters: {
                    name: '',
                    created_by: '',
                },
            }),
        });

    case ProductGroupTypes.RESET_CHOSEN_PACKAGES_FILTERS_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            chosen_packages: Object.assign({}, state.chosen_packages, {
                filters: {
                    name: '',
                    created_by: '',
                },
            }),
        });

    case ProductGroupTypes.RESET_PACKAGES_PAGINATION_FOR_PRODUCT_GROUP:
        return Object.assign({}, state, {
            packages: Object.assign({}, state.packages, {
                offset: 0,
            }),
        });

    default:
        return state;
    }
}
